/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

// Field validation constants
export const FIELD_VALIDATIONS = {
  LOCATION_NAME: {
    MAX_LENGTH: 50,
    MAX_LENGTH1: 10,
    MAX_LENGTH2: 15,
    ERROR_MESSAGE: 'Limit exceeds 50 characters',
    ERROR_MESSAGE1: 'Limit exceeds 10 characters',
    ERROR_MESSAGE2: 'Limit exceeds 15 characters'
  }
} as const;
